<script>
    import Player from "../components/Player.svelte";

    export let id
</script>

<main>
    <Player stream={id} full={true} />
</main>
